module.exports = __webpack_public_path__ + "static/media/monitor.1b3372cd.svg";